import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { OnTheRecordTimesConflicts } from './OnTheRecordTimesConflicts';
/** Response for when modifying on-the-record times would result in conflicts. */
export class OnTheRecordTimesConflictResponse {
    /**
     * @param conflicts The conflicts to present to the user for confirmation.
     * @param conflictResolutionToken A hash of the conflicts.
     */
    constructor(conflicts, conflictResolutionToken) {
        this.conflicts = conflicts;
        this.conflictResolutionToken = conflictResolutionToken;
    }
}
__decorate([
    Type(() => OnTheRecordTimesConflicts),
    __metadata("design:type", OnTheRecordTimesConflicts)
], OnTheRecordTimesConflictResponse.prototype, "conflicts", void 0);
